/**
 * @file: formatChatTime.ts
 *
 * Time formatting for the centered chat time-slice marker.
 */

/**
 * Format a chat message createdAt timestamp for the centered time-slice
 * marker. today → `HH:mm`; yesterday → `昨天 HH:mm`; older → `YYYY-MM-DD
 * HH:mm`. The reference design uses English ("Yesterday 09:40") but
 * this app is Chinese-first; mirror the convention.
 */
export function formatChatTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  const startOfDay = (date: Date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  const dayDiff = Math.floor(
    (startOfDay(now) - startOfDay(d)) / (24 * 60 * 60 * 1000),
  );
  const pad = (n: number) => String(n).padStart(2, '0');
  const hm = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  if (dayDiff <= 0) return hm;
  if (dayDiff === 1) return `昨天 ${hm}`;
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
    d.getDate(),
  )} ${hm}`;
}
